import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M7.83 11L11.41 7.41L10 6L4 12L10 18L11.41 16.59L7.83 13H20V11H7.83Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "ShortLeft"
);
